import React from 'react';
import styled from 'styled-components';
import profilePic from '../player_images/profile-pic.png';

const Card = styled.div`
  position: relative;
  width: 350px;
  padding: 1.5rem;
  background: #1e2432;
  border-radius: 15px;
  color: white;
`;

const ImageSection = styled.div`
  margin: -1.5rem -1.5rem 1.5rem -1.5rem;
  position: relative;
  border-radius: 15px 15px 0 0;
  overflow: hidden;
  height: 150px;
  background: linear-gradient(45deg, #2a3142, #1e2432);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.9;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }
`;

const ImageOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: linear-gradient(transparent, rgba(30, 36, 50, 0.9));
  color: white;
`;

const Title = styled.div`
  color: aqua;
  font-size: 1.5rem;
`;

const Subtitle = styled.div`
  color: #8b95a5;
  font-size: 0.9rem;
`;

const Profile = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const Avatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 12px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ProfileInfo = styled.div`
  h2 {
    font-size: 1.2rem;
    margin-bottom: 0.2rem;
    margin-top: 3px;
  }

  p {
    color: aqua;
    font-size: 0.9rem;
    margin-bottom: 0.2rem;
    margin-top: 0px;
  }

  .id {
    color: #8b95a5;
    font-size: 0.8rem;
  }
`;

const SkillsSection = styled.div`
  h3 {
    color: #8b95a5;
    font-size: 0.9rem;
    margin-bottom: 0.8rem;
  }
`;

const Skills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

const Skill = styled.span`
  background: #2a3142;
  color: aqua;
  padding: 0.4rem 0.8rem;
  border-radius: 5px;
  font-size: 0.9rem;
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;

  a {
    color: #8b95a5;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: color 0.2s ease;

    &:hover {
      color: #4a9eff;
    }
  }

  .download-vcf {
    background: #4a9eff;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    margin-top: 0.5rem;
    justify-content: center;
    
    &:hover {
      background: #3a8eff;
      color: white;
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;

  a {
    color: #4a9eff;
    text-decoration: none;
  }
`;

const DigitalCard = () => {
  return (
    <Card>
      <ImageSection>
        <img
          src="https://images.unsplash.com/photo-1605379399642-870262d3d051?q=80&w=1000&auto=format&fit=crop"
          alt="Developer Workspace"
        />
        <ImageOverlay>
          <Title>Frontend Architect</Title>
          <Subtitle>Code Advocate and Consultant</Subtitle>
        </ImageOverlay>
      </ImageSection>

      <Profile>
        <Avatar>
          <img src={profilePic} alt="Profile" />
        </Avatar>
        <ProfileInfo>
          <h2>Rohan Rajani</h2>
          <p>10+ years of experience</p>
        </ProfileInfo>
      </Profile>
      <ContactInfo>
        <a href="http://rohanrajani.com">🌐 rohanrajani.com</a>
        <a href="mailto:rajanirohan@gmail.com">✉️ rajanirohan@gmail.com</a>
        <a href="tel:+918866182067">📱 +91 8866182067</a>
        <a href="https://www.linkedin.com/in/rohan-rajani-15676156/">💼 LinkedIn</a>
        <a href="/rohan-rajani.vcf" download className="download-vcf">
          📇 Download Contact Card
        </a>
      </ContactInfo>
      <SkillsSection>
        <h3>EXPERTISE</h3>
        <Skills>
          <Skill>JavaScript</Skill>
          <Skill>TypeScript</Skill>
          <Skill>React</Skill>
          <Skill>Next.js</Skill>
          <Skill>React-Native</Skill>
          <Skill>Socket.io</Skill>
          <Skill>Redux</Skill>
          <Skill>Performance Optimization</Skill>
          <Skill>Code Policy</Skill>
          <Skill>Scalability and Maintainability</Skill>
        </Skills>
      </SkillsSection>
      <SocialLinks>
      </SocialLinks>
    </Card>
  );
};

export default DigitalCard;
